import _ from 'lodash'

/**
 * Gets the number of decimal places in a number
 */
export const getNumberOfDecimals = (value: number): number => {
  if (Math.floor(value) === value) return 0
  const valueStr = value.toString()
  const decimalIndex = valueStr.indexOf('.')
  return decimalIndex === -1 ? 0 : valueStr.length - decimalIndex - 1
}

/**
 * Rounds a number to specified decimal places using Math.pow for precision
 */
export const roundToDecimalsWithPow = (value: number, decimals: number): number => {
  const multiplier = Math.pow(10, decimals)
  return Math.round(value * multiplier) / multiplier
}

/**
 * Rounds a number to an integer, handling floating point precision issues
 */
export const roundToInt = (value: number): number => {
  return Math.round(value)
}

export const isMultiple = (number: number, step: number): boolean => {
  const precision = Math.abs(Math.floor(Math.log10(Math.abs(step)))) + 10
  const remainder = _.round(number % step, precision)
  return remainder === 0 || remainder === step
}

export const isInRange = (number: number, min: number, max: number): boolean => {
  return number <= max && number >= min
}

/**
 * Rounds a value UP to the nearest multiple of step.
 * Output is normalised to step's decimal precision to strip IEEE-754 noise.
 *
 * Examples:
 *   ceilToStep(5.25, 0.1) → 5.3
 *   ceilToStep(5.0, 0.5)  → 5.0  (exact multiple unchanged)
 *   ceilToStep(5.1, 0.5)  → 5.5
 *   ceilToStep(5.25, 1)   → 6
 *   ceilToStep(0, 0.5)    → 0
 */
export const ceilToStep = (value: number, step: number): number => {
  const decimals = getNumberOfDecimals(step)
  return roundToDecimalsWithPow(Math.ceil(value / step) * step, decimals)
}
